<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import VueI18n from 'vue-i18n'
import Vue from 'vue'

Vue.use(VueI18n)
export default {
  name: 'app',
  components: {
  },
  data() {
    return {

    }
  },
  methods: {

  },
  created() {
    const url = process.env.VUE_APP_BACKEND_URL || "http://localhost:8081"
    this.$store.commit('setUrl', url)
  }
}
</script>

<style lang="scss">
  @import "@/assets/styles/app.sass"
</style>
